var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-user',{ref:"viewUser",attrs:{"show-back-button":false,"show-action-buttons":false},on:{"viewEntry":_vm.viewEntry}})
}
var staticRenderFns = []

export { render, staticRenderFns }